import { useEffect, useState } from "react";

export default function useDeviceOS() {
  const [device, setDevice] = useState("unknown");

  const ua = navigator.userAgent || navigator.vendor || window.opera;

  useEffect(() => {
    if (/android/i.test(ua)) {
      setDevice("android");
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      setDevice("ios");
    } else {
      setDevice("other");
    }
  }, [ua]);

  return device;
}
